export const API_GET_ALL_CREDENTIALS = '/admin/credenciales/';
export const API_PUT_CREDENTIALS = '/admin/credenciales/actualizar/credenciales/'
export const API_POST_CREDENTIALS = '/admin/credenciales/registro/credenciales/'
export const API_GET_SEARCH_CREDENTIALS = '/admin/credenciales/buscar/credenciales/'
export const API_GET_ACTUAL_CREDENTIAL = '/admin/credenciales/asignacion/actual/'
export const API_GET_LIST_CREDENTIALS = '/admin/credenciales/listar'
export const API_GET_ASIGN_CREDENTIAL = '/admin/credenciales/asignacion/'
